import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import TopBar from "../../components/common/public/TopBar";
import PublicFooter from "../../components/common/public/Footer";
import { GlobalStyles } from "../../constants/styles";
import useTranslation from "../../i18n/useTranslation";

function Advertise() {
    const { t } = useTranslation();

    useEffect(() => {
        const prevTitle = document.title;
        document.title = t("advertisePage.meta.title");

        return () => {
            document.title = prevTitle;
        };
    }, [t]);

    return (
        <div
            style={{
                backgroundColor: "#14151a",
                color: "#ffffff",
                fontFamily: "'Poppins', sans-serif",
                overflowX: "hidden",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <TopBar imgPath="/dist/img/angeonx-sports.png" />

            <div
                className="container"
                style={{
                    margin: "0 auto",
                    maxWidth: "1200px",
                    padding: "0 20px",
                    flex: 1,
                }}
            >
                <div
                    className="p-4 p-md-5 rounded mt-4"
                    style={{
                        backgroundColor: "#1f1f2e",
                        color: "#ffffff",
                        border: "1px solid var(--kbs-primary, #00adff)",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.8)",
                    }}
                >
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <h1
                                style={{
                                    color: "var(--kbs-primary, #00adff)",
                                    fontWeight: 600,
                                    lineHeight: 1.2,
                                }}
                            >
                                {t("advertisePage.hero.title")}
                            </h1>

                            <p
                                style={{
                                    marginTop: "16px",
                                    fontSize: "1rem",
                                    lineHeight: 1.5,
                                }}
                            >
                                {t("advertisePage.hero.description1")}
                                <br />
                                {t("advertisePage.hero.description2")}
                            </p>

                            <ul
                                style={{
                                    marginTop: "16px",
                                    lineHeight: 1.5,
                                    paddingLeft: "1.2rem",
                                }}
                            >
                                <li>{t("advertisePage.hero.bullet1")}</li>
                                <li>{t("advertisePage.hero.bullet2")}</li>
                                <li>{t("advertisePage.hero.bullet3")}</li>
                                <li>{t("advertisePage.hero.bullet4")}</li>
                            </ul>

                            <p
                                style={{
                                    marginTop: "16px",
                                    color: "var(--kbs-primary, #00adff)",
                                    fontWeight: 500,
                                    fontSize: "0.95rem",
                                }}
                            >
                                {t("advertisePage.hero.pricing")}
                            </p>

                            <NavLink
                                to="/register"
                                className="btn btn-lg mt-3"
                                style={{
                                    backgroundColor: "var(--kbs-primary, #00adff)",
                                    color: "var(--kbs-text-on-primary, #14151a)",
                                    fontWeight: 600,
                                    minWidth: "220px",
                                    borderRadius: "8px",
                                }}
                                state={{
                                    accountType: "sponsor",
                                }}
                            >
                                {t("advertisePage.hero.createSponsorAccount")}
                            </NavLink>

                            <div
                                style={{
                                    fontSize: "0.8rem",
                                    marginTop: "8px",
                                    color: "#8d929d",
                                }}
                            >
                                {t("advertisePage.hero.alreadyHaveAccount")}{" "}
                                <NavLink
                                    to="/login"
                                    style={{
                                        color: "var(--kbs-primary, #00adff)",
                                        textDecoration: "underline",
                                        fontWeight: 500,
                                    }}
                                >
                                    {t("advertisePage.hero.signIn")}
                                </NavLink>
                            </div>
                        </div>

                        <div className="col-md-4 text-center mt-4 mt-md-0">
                            <div
                                style={{
                                    backgroundColor: GlobalStyles.colors.shark,
                                    border: "1px solid #fff",
                                    borderRadius: "16px",
                                    padding: "16px",
                                    maxWidth: "320px",
                                    margin: "0 auto",
                                    boxShadow: "0 20px 40px rgba(0,0,0,0.9)",
                                    textAlign: "left",
                                    fontSize: "0.8rem",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "flex-start",
                                        gap: "12px",
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: "var(--kbs-primary, #00adff)",
                                            borderRadius: "8px",
                                            width: "56px",
                                            height: "56px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: 700,
                                            color: "var(--kbs-text-on-primary, #14151a)",
                                            fontSize: "0.75rem",
                                            lineHeight: 1.1,
                                            textAlign: "center",
                                        }}
                                    >
                                        {t("advertisePage.preview.logoPlaceholder")}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <div
                                            style={{
                                                color: "#ffffff",
                                                fontWeight: 600,
                                                lineHeight: 1.3,
                                                fontSize: "0.9rem",
                                            }}
                                        >
                                            {t("advertisePage.preview.cardTitle")}
                                        </div>
                                        <div
                                            style={{
                                                color: "#8d929d",
                                                fontSize: "0.8rem",
                                                lineHeight: 1.4,
                                                marginTop: "4px",
                                            }}
                                        >
                                            {t("advertisePage.preview.cardText")}
                                        </div>

                                        <div
                                            style={{
                                                marginTop: "6px",
                                                fontSize: "0.75rem",
                                                textDecoration: "underline",
                                                color: "#ffffff",
                                                fontWeight: 500,
                                            }}
                                        >
                                            {t("advertisePage.preview.viewMore")}
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            color: "#8d929d",
                                            fontSize: "0.8rem",
                                            fontWeight: 500,
                                        }}
                                    >
                                        ✕
                                    </div>
                                </div>

                                <div style={{ marginTop: "16px" }}>
                                    <div
                                        style={{
                                            backgroundColor: "var(--kbs-primary, #00adff)",
                                            color: "#000000",
                                            fontWeight: 600,
                                            width: "100%",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        <span>{t("advertisePage.preview.seeMore")}</span>
                                        <span style={{ fontWeight: 700 }}>›</span>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        fontSize: "0.7rem",
                                        color: "#8d929d",
                                        marginTop: "10px",
                                    }}
                                >
                                    {t("advertisePage.preview.sponsoredPlacement")}
                                </div>
                            </div>

                            <div
                                style={{
                                    backgroundColor: GlobalStyles.colors.shark,
                                    border: "1px solid #fff",
                                    borderRadius: "16px",
                                    padding: "16px",
                                    maxWidth: "320px",
                                    margin: "24px auto 0 auto",
                                    boxShadow: "0 20px 40px rgba(0,0,0,0.9)",
                                    textAlign: "left",
                                    fontSize: "0.8rem",
                                }}
                            >
                                <div
                                    style={{
                                        backgroundColor: "var(--kbs-primary, #00adff)",
                                        color: "var(--kbs-text-on-primary, #14151a)",
                                        borderRadius: "12px",
                                        minHeight: "120px",
                                        fontWeight: 700,
                                        fontSize: "0.9rem",
                                        lineHeight: 1.4,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "12px",
                                    }}
                                >
                                    {t("advertisePage.preview.expandedTitle")}
                                    <br />
                                    {t("advertisePage.preview.expandedSubtitle")}
                                </div>

                                <div style={{ marginTop: "16px", color: "#ffffff" }}>
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            fontSize: "0.9rem",
                                            lineHeight: 1.4,
                                            marginBottom: "8px",
                                        }}
                                    >
                                        {t("advertisePage.preview.expandedHeadline")}
                                    </div>
                                    <div
                                        style={{
                                            color: "#ffffff",
                                            fontSize: "0.8rem",
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        {t("advertisePage.preview.expandedText")}
                                    </div>
                                </div>

                                <div style={{ marginTop: "16px" }}>
                                    <div
                                        style={{
                                            backgroundColor: "var(--kbs-primary, #00adff)",
                                            color: "#000000",
                                            fontWeight: 600,
                                            width: "100%",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        <span>{t("advertisePage.preview.seeMore")}</span>
                                        <span style={{ fontWeight: 700 }}>›</span>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        fontSize: "0.7rem",
                                        color: "#8d929d",
                                        marginTop: "10px",
                                    }}
                                >
                                    {t("advertisePage.preview.expandedFooter")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-12 text-center">
                        <h2 style={{ color: "var(--kbs-primary, #00adff)", fontWeight: 600 }}>
                            {t("advertisePage.howItWorks.title")}
                        </h2>
                    </div>

                    <div className="col-md-4 mt-4">
                        <div
                            className="card p-3 h-100"
                            style={{
                                backgroundColor: "#1f1f2e",
                                color: "#ffffff",
                                border: "1px solid #1f1f2e",
                            }}
                        >
                            <h5 style={{ color: "var(--kbs-primary, #00adff)", fontWeight: 600 }}>
                                {t("advertisePage.howItWorks.step1Title")}
                            </h5>
                            <p style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
                                {t("advertisePage.howItWorks.step1Text")}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-4 mt-4">
                        <div
                            className="card p-3 h-100"
                            style={{
                                backgroundColor: "#1f1f2e",
                                color: "#ffffff",
                                border: "1px solid #1f1f2e",
                            }}
                        >
                            <h5 style={{ color: "var(--kbs-primary, #00adff)", fontWeight: 600 }}>
                                {t("advertisePage.howItWorks.step2Title")}
                            </h5>
                            <p style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
                                {t("advertisePage.howItWorks.step2Text")}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-4 mt-4">
                        <div
                            className="card p-3 h-100"
                            style={{
                                backgroundColor: "#1f1f2e",
                                color: "#ffffff",
                                border: "1px solid #1f1f2e",
                            }}
                        >
                            <h5 style={{ color: "var(--kbs-primary, #00adff)", fontWeight: 600 }}>
                                {t("advertisePage.howItWorks.step3Title")}
                            </h5>
                            <p style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
                                {t("advertisePage.howItWorks.step3Text")}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row mt-5 mb-5">
                    <div className="col-md-6 mt-4">
                        <div
                            className="card p-3 h-100"
                            style={{
                                backgroundColor: "#1f1f2e",
                                color: "#ffffff",
                                border: "1px solid #1f1f2e",
                            }}
                        >
                            <h5 style={{ color: "var(--kbs-primary, #00adff)", fontWeight: 600 }}>
                                {t("advertisePage.faq.whoIsThisForTitle")}
                            </h5>
                            <p style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
                                {t("advertisePage.faq.whoIsThisForText")}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-6 mt-4">
                        <div
                            className="card p-3 h-100"
                            style={{
                                backgroundColor: "#1f1f2e",
                                color: "#ffffff",
                                border: "1px solid #1f1f2e",
                            }}
                        >
                            <h5 style={{ color: "var(--kbs-primary, #00adff)", fontWeight: 600 }}>
                                {t("advertisePage.faq.longContractTitle")}
                            </h5>
                            <p style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
                                {t("advertisePage.faq.longContractText")}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="text-center mb-5">
                    <NavLink
                        to="/register"
                        className="btn btn-lg"
                        style={{
                            backgroundColor: "var(--kbs-primary, #00adff)",
                            color: "var(--kbs-text-on-primary, #14151a)",
                            fontWeight: 600,
                            minWidth: "220px",
                            borderRadius: "8px",
                        }}
                        state={{
                            accountType: "sponsor",
                        }}
                    >
                        {t("advertisePage.finalCta.createSponsorAccount")}
                    </NavLink>

                    <div
                        style={{
                            fontSize: "0.8rem",
                            marginTop: "8px",
                            color: "#8d929d",
                        }}
                    >
                        {t("advertisePage.finalCta.alreadySponsor")}{" "}
                        <NavLink
                            to="/login"
                            style={{
                                color: "var(--kbs-primary, #00adff)",
                                textDecoration: "underline",
                                fontWeight: 500,
                            }}
                        >
                            {t("advertisePage.finalCta.signIn")}
                        </NavLink>
                    </div>
                </div>
            </div>

            <PublicFooter imgPath="/dist/img/" />
        </div>
    );
}

export default Advertise;
